import { getAmplitudeInstance } from '../amplitudeHelpers';
import MapLocation from '../enums/MapLocation';
import MapOverlay from '../enums/MapOverlay';
import TimeDrawerAction from '../enums/TimeDrawerAction';

type logMapOverlayTimeDrawerActionTappedParams = {
  custom_route_id?: string;
  map_location?: MapLocation;
  map_overlay?: MapOverlay;
  period_offset?: number;
  time_drawer_action?: TimeDrawerAction;
  to_overlay?: MapOverlay;
  trail_id?: string;
};

/**
 * A user interacts with the period picker or scrubber on a map overlay, such as the fall foliage legend or the trail conditions timeline. Event should fire once per action type taken per overlay per session. (E.g. if the user changes the date twice and interacts with the scrubber three times, the event should fire once for changing the date and once for scrubbing.)
 * @param params - Attributes to log with the amplitude event
 * @param params.custom_route_id - The custom route ID of the custom route being viewed, if applicable
 * @param params.map_location - The location of the map where the interaction occurred
 * @param params.map_overlay - A string representing the map overlay selected
 * @param params.period_offset - How far the user moved from the current period, in the overlay's own units — weeks ahead for fall foliage, hours for the conditions timeline. 0 is the period in progress.
 * @param params.time_drawer_action - The action the user takes in the map overlay drawer
 * @param params.to_overlay - When the user takes a swapping overlay action
 * @param params.trail_id - Trail ID of the recap if applicable
 */
const logMapOverlayTimeDrawerActionTapped = (
  { custom_route_id, map_location, map_overlay, period_offset, time_drawer_action, to_overlay, trail_id }: logMapOverlayTimeDrawerActionTappedParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'map overlay time drawer action tapped',
    {
      'custom route id': custom_route_id,
      'map location': map_location,
      'map overlay': map_overlay,
      'period offset': period_offset,
      'time drawer action': time_drawer_action,
      'to overlay': to_overlay,
      'trail id': trail_id
    },
    callback
  );
};

export default logMapOverlayTimeDrawerActionTapped;
